import api from "./api";

class OrderApi extends api {
  constructor() {
    super();
    this.setup();
  }

  store(data) {
    return this.post('order', data, 1);
  }
}

export default new OrderApi();
